import DayEndQueries from './DayEndQueries'

const mvCartTransactions = {
  mvCartTransactions: {
    ...DayEndQueries
  }
}

export default mvCartTransactions